import styled, { css } from "styled-components";
import React from "react";

export interface ProgressiveDivProps {
  /**
   * Amount filed
   */
  amount: number;
  /**
   * What is Amount Color
   */
  amountColor: string;
  /**
   * Price filed
   */
  price: number;
  /**
   * What is Price Color
   */
  priceColor: string;
  /**
   * Progress Color
   */
  progressColor: string;
  /**
   * Progress direction -- true = rtl & false = ltr
   */
  isRtl: boolean;
  /**
   * Progress Level --- e: 80%
   */
  progressLvl: number;
  /**
   * Has Total ?
   */
  totalValue?: number;
  /**
   * CLick On List !
   */
  onRowClicked: (column: string, property: any) => void;
}
interface IBaseStyle {
  totalValue?: number
}
/**
 * Progressive Div Wrapper
 */
const ProDivWrapper = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  padding: 5px;
  height: 33px;
  justify-content: space-between;
`;
/**
 * Progressive Div Span
 */
const ProDivSpan = styled.span<IBaseStyle>`
  font-size: 12px;
  ${(p) =>
    p.totalValue &&
    css`
        width: 33.33%;
    `};
  
  &.chart-amount {
    text-align: right;
  }
  &.chart-total-price {
    text-align: left;
  }
`;
/**
 * Main Progressive Div UI Component
 * @param amount
 * @param amountColor
 * @param price
 * @param priceColor
 * @param progressColor
 * @param isRtl
 * @param progressLvl
 * @param totalValue
 * @param onRowClicked
 * @constructor
 */
const ProgressiveDiv: React.FC<ProgressiveDivProps> = ({
  amount,
  amountColor,
  price,
  priceColor,
  progressColor,
  isRtl,
  progressLvl,
  totalValue,
  onRowClicked,
}) => {

  return (

    <ProDivWrapper
      style={{
        background: `linear-gradient(${isRtl ? "90deg" : "-90deg"},
                 ${progressColor}    ${progressLvl}%, transparent ${progressLvl}%)`,
      }}
    >
      <ProDivSpan
          onClick={() => onRowClicked('amount', amount)}
          totalValue={totalValue} style={{ color: amountColor }} className="chart-amount">
        {amount}
      </ProDivSpan>
      <ProDivSpan
          onClick={() => onRowClicked('price', price)}
          totalValue={totalValue} style={{ color: priceColor }} className="chart-price">
        {price.toLocaleString()}
      </ProDivSpan>
      {totalValue && (
        <ProDivSpan
            onClick={() => onRowClicked('totalValue', totalValue)}
            totalValue={totalValue} style={{ color: amountColor }} className="chart-total-price">
          {totalValue.toLocaleString()}
        </ProDivSpan>
      )}
    </ProDivWrapper>
  );
};

export default ProgressiveDiv;
